/* eslint-disable global-require */

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions');
}

// only import `fetch` in a browser environment
if (typeof window !== 'undefined') {
  require('whatwg-fetch');
}


Object.assign = require('object-assign');

// support for CustomEvents in IE11
// from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#polyfill
/* eslint-disable */
(function () {
  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  window.CustomEvent = CustomEvent;
})();
/* eslint-enable */
